export class UpdateFileMetaData {
    name: string;
    type: string;
    numChanges = 0;
    onlyWhitespaces = false;
}
